import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AuthoritySection() {
  return <section className="py-24 bg-primary" data-id="element-6">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-7">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-8">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-9">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-10">
              Why Nothing Fits Right
            </h2>
            <div className="space-y-6 text-lg text-text-muted leading-relaxed" data-id="element-11">
              <p data-id="element-12">
                Most fashion brands design for a fit model who is{' '}
                <strong className="text-white" data-id="element-13">5'8" or taller</strong>.
              </p>
              <p data-id="element-14">
                When they create smaller sizes, they just shrink the pattern
                overall. But that doesn't work. When you simply scale down a
                pattern, the proportions break.
              </p>
              <p data-id="element-15">
                The rise is still too long. The knee break hits your shin. The
                waist sits on your hips. It's a fundamental geometry problem
                that "sizing down" can't fix.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-card p-8 rounded-2xl shadow-lg border border-border" data-id="element-16">
            <div className="grid grid-cols-2 gap-4 text-center" data-id="element-17">
              <div className="space-y-4 pb-4 border-r border-gray-100 pr-4" data-id="element-18">
                <div className="text-sm font-semibold text-text-muted uppercase tracking-wider" data-id="element-19">
                  Standard Industry
                </div>
                <div className="aspect-[3/4] bg-gray-50 rounded-lg flex items-center justify-center relative overflow-hidden group" data-id="element-20">
                  <div className="absolute inset-0 flex flex-col items-center justify-center opacity-20" data-id="element-21">
                    <div className="w-1/2 h-3/4 border-2 border-dashed border-gray-400 rounded-full" data-id="element-22"></div>
                  </div>
                  <XCircle className="w-12 h-12 text-red-400 relative z-10" data-id="element-23" />
                  <div className="absolute bottom-4 text-xs font-medium text-red-500" data-id="element-24">
                    Scaled Down
                  </div>
                </div>
                <p className="text-sm text-text-muted" data-id="element-25">Proportions distorted</p>
              </div>

              <div className="space-y-4 pb-4 pl-4" data-id="element-26">
                <div className="text-sm font-semibold text-accent uppercase tracking-wider" data-id="element-27">
                  HemNoMore Way
                </div>
                <div className="aspect-[3/4] bg-accent/5 rounded-lg flex items-center justify-center relative overflow-hidden" data-id="element-28">
                  <div className="absolute inset-0 flex flex-col items-center justify-center opacity-20" data-id="element-29">
                    <div className="w-1/2 h-1/2 border-2 border-solid border-accent rounded-full" data-id="element-30"></div>
                  </div>
                  <CheckCircle2 className="w-12 h-12 text-green-500 relative z-10" data-id="element-31" />
                  <div className="absolute bottom-4 text-xs font-medium text-green-600" data-id="element-32">
                    Proportion Correct
                  </div>
                </div>
                <p className="text-sm text-text-muted" data-id="element-33">
                  Designed for your height
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}